import React from 'react';
import {
  FDStack, FDImage, FDHeadlineText,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import { CompareColumn } from './CompareColumn';

export const CompareFacetSections = () => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();
  const sections = resource.attr('influencerCompareFacetSectionCollection').resources().list();

  const renderImage = ({ section }) => (
    section.withRelationship(fr.relationships.image.name,
      (rel) => (
        <FDImage
          src={rel.link('related').url()}
          alt={rel.meta('altText') || ''}
          width={'100%'}
          height={'100%'}
          objectFit={'cover'}
          objectPosition={'center'}
        />
      ),
      () => null)
  );

  return (
    <FDStack direction={'column'} spacing={isMobile ? 6 : 10} flex={1} width={'100%'} alignItems={'center'} justifyContent={isMobile ? 'center' : undefined}>
      {sections.map((section, i) => {
        // we're alternating which side the image is on (on desktop)
        let imageLocation = 'right';
        if (i % 2 === 0) {
          imageLocation = 'left';
        }

        // on mobile, image is always above the title
        if (isMobile) {
          imageLocation = 'top';
        }
        return (
          <FDStack direction={'column'} spacing={2}>
            {/* top image */}
            {imageLocation === 'top' && renderImage({ section })}

            <FDStack direction={'row'} spacing={2}>
              {/* left image */}
              {imageLocation === 'left' && (
                <FDStack flex={2}>
                  {renderImage({ section })}
                </FDStack>
              )}

              <FDStack flex={3} direction={'column'} spacing={2}>
                {/* title with limited width on desktop */}
                <FDStack width={isMobile ? '100%' : '50%'}>
                  <FDHeadlineText size={'md'} value={section.attr('title')} />
                </FDStack>
                {/* columns comparing facet and traditional advisors */}
                <FDStack spacing={2}>
                  {/* facet */}
                  <CompareColumn
                    title={section.attr('facetHeading')}
                    descriptions={section.attr('facetDescriptions')}
                    descriptionColor={'info'}
                    descriptionAppearance={'flat'}
                    showChecks
                  />
                  {/* traditional advisors */}
                  <CompareColumn
                    title={section.attr('compareHeading')}
                    descriptions={section.attr('compareDescriptions')}
                    descriptionColor={'subtle'}
                    descriptionAppearance={'outlined'}
                  />
                </FDStack>
              </FDStack>

              {/* right image */}
              {imageLocation === 'right' && (
              <FDStack flex={2}>
                {renderImage({ section })}
              </FDStack>
              )}

            </FDStack>
          </FDStack>);
      })}
    </FDStack>
  );
};
